// extracted by mini-css-extract-plugin
export default {"title":"T--z","warning":"U--z","sizeOptionsLegendText":"V--z"};